import React from 'react';
import '../../styles/Footer.css';

const Footer = () => {
  return (
    <footer>
      <div className="footer-simple">
        <p>© 2026 Viewly</p>
      </div>
    </footer>
  );
};

export default Footer;
